import React, { createContext, useContext, useRef } from "react";
import GlobalMessage, {
  GlobalMessageHandle,
  IGlobalMessage,
} from "../components/global/GlobalMessage";

interface IGlobalMessageContextType {
  showGlobalMessage: (props: IGlobalMessage) => void;
  showGlobalMessageList: (globalMessageList: IGlobalMessage[]) => void;
  clearGlobalMessage: () => void;
}

export const GlobalMessageContext = createContext<
  IGlobalMessageContextType | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useGlobalMessage = () => {
  const context = useContext(GlobalMessageContext);
  if (!context) {
    throw new Error(
      "useGlobalMessage must be used within a GlobalMessageProvider",
    );
  }
  return context;
};

interface GlobalMessageProviderProps {
  children: React.ReactNode;
}

export const GlobalMessageProvider: React.FC<GlobalMessageProviderProps> = ({
  children,
}) => {
  const globalMessageRef = useRef<GlobalMessageHandle>(null);

  const showGlobalMessage = (props: IGlobalMessage) => {
    globalMessageRef.current?.showGlobalMessage(props);
  };

  const showGlobalMessageList = (globalMessageList: IGlobalMessage[]) => {
    globalMessageRef.current?.showGlobalMessageList(globalMessageList);
  };

  const clearGlobalMessage = () => {
    globalMessageRef.current?.clearGlobalMessage();
  };

  return (
    <GlobalMessageContext.Provider
      value={{
        showGlobalMessage,
        showGlobalMessageList,
        clearGlobalMessage,
      }}
    >
      {children}
      <GlobalMessage ref={globalMessageRef} />
    </GlobalMessageContext.Provider>
  );
};
